import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-665afe0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "X-Global",
      class: "logo"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "БИЗНЕС СЕТЬ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Новая эко-система бизнеса, где компании находят друг друга, проверяют надёжность и строят партнёрства ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "slide-content marketplace-card"
}
const _hoisted_5 = { class: "marketplace-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Маркетплейс B2B", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Работайте с проверенными компаниями - прозрачно и напрямую", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circles" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle green" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle grey" })
], -1))
const _hoisted_9 = {
  key: 1,
  class: "slide-content"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Проверка и сделка", -1))
const _hoisted_11 = { class: "search" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "search-text" }, " Находите всю информацию по вашим контрагентам, добавляйте их в друзья, отслеживайте события ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circles" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle grey" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle green" })
], -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "features" }
const _hoisted_16 = { class: "feature-circle" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "feature-label" }

import main1 from "@/assets/images/hero-icons/main-1.svg";
import main2 from "@/assets/images/hero-icons/main-2.svg";
import main3 from "@/assets/images/hero-icons/main-3.svg";
import main4 from "@/assets/images/hero-icons/main-4.svg";
import main5 from "@/assets/images/hero-icons/main-5.svg";
import arrowRight from "@/assets/images/icons/arrow-main.svg";
import arrowLeft from "@/assets/images/icons/arrow-left.svg";
import SearchComponent from "../SearchComponent.vue";

import { ref } from "vue";
const SWIPE_THRESHOLD = 50;


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroSection',
  setup(__props) {

const slide = ref(0);
const arrowIcon = ref(arrowRight || arrowLeft);

const touchStartX = ref<null | number>(null);
const touchEndX = ref<null | number>(null);
const features = [
  {
    label:
      "Комплексный анализ благонадежности на основе 100+ параметров проверки",
    icon: main1,
  },
  { label: "Безопасные сделки только с надежными компаниями", icon: main2 },
  { label: "Товары и услуги для вашего бизнеса", icon: main3 },
  { label: "Детальная информация из более чем 40+ источников", icon: main4 },
  { label: "Сделка и чат внутри платформы", icon: main5 },
];

function toggleSlide() {
  slide.value = slide.value === 0 ? 1 : 0;
  arrowIcon.value = slide.value === 0 ? arrowRight : arrowLeft;
  // arrowBg.value = slide.value === 0 ? "#00C37F" : "#FFFFFF";
  // console.log("arrowBg", arrowBg.value);
}

function onTouchStart(e: TouchEvent) {
  touchStartX.value = e.changedTouches[0].clientX;
  touchEndX.value = null;
}

function onTouchEnd(e: TouchEvent) {
  if (touchStartX.value === null) return;
  touchEndX.value = e.changedTouches[0].clientX;

  const diff = (touchStartX.value || 0) - (touchEndX.value || 0);

  if (diff > SWIPE_THRESHOLD && slide.value === 0) {
    toggleSlide();
  }

  if (diff < -SWIPE_THRESHOLD && slide.value === 1) {
    toggleSlide();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "slider-card",
        onTouchstart: onTouchStart,
        onTouchend: onTouchEnd
      }, [
        (slide.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createVNode(_component_router_link, {
                  to: "/marketplace",
                  class: "market-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Перейти в В2В маркетплейс")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(SearchComponent)
              ]),
              _hoisted_12,
              _hoisted_13
            ])),
        _createElementVNode("button", {
          class: "arrow",
          onClick: toggleSlide
        }, [
          _createElementVNode("img", {
            src: arrowIcon.value,
            alt: "arrow"
          }, null, 8, _hoisted_14)
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (f) => {
        return _createElementVNode("div", {
          class: "feature",
          key: f.label
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              src: f.icon,
              alt: ""
            }, null, 8, _hoisted_17)
          ]),
          _createElementVNode("div", _hoisted_18, _toDisplayString(f.label), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})